import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, ConsentPayload, PaginatedResponse, PropertyStatus, TierModel } from '@letly/models';
import { CreatePropertyModel } from './create-property.reducers';
import { ApiService } from '@letly/services';
import { environment } from '../../../../env/environment';
import { CreatePropertyImageModel } from '../models/create-property-image.req.model';

@Injectable({
  providedIn: 'root'
})
export class CreatePropertyService {

  private apiService = inject(ApiService);

  createProperty(
    data: CreatePropertyModel
  ): Observable<ApiResponse<CreatePropertyModel>> {
    return this.apiService.post(
      environment.listingBaseUrl + `/v1/landlords/self/properties`,
      data
    );
  }

  updateProperty(
    data: CreatePropertyModel
  ): Observable<ApiResponse<CreatePropertyModel>> {
    return this.apiService.put(
      environment.listingBaseUrl + `/v1/landlords/self/properties/${data.id}`,
      { ...data }
    );
  }

  addImagesToProperty(
    propertyId: string,
    data: CreatePropertyImageModel
  ): Observable<ApiResponse<CreatePropertyModel>> {
    return this.apiService.post(
      environment.listingBaseUrl +
      `/v1/landlords/self/properties/${propertyId}/images`,
      data
    );
  }

  deleteImagesFromProperty(
    propertyId: string,
    imageId: string
  ): Observable<ApiResponse<CreatePropertyModel>> {
    return this.apiService.delete(
      environment.listingBaseUrl +
      `/v1/landlords/self/properties/${propertyId}/images/${imageId}`
    );
  }

  updatePropertyDetail(
    id: string,
    data: Partial<CreatePropertyModel>
  ): Observable<ApiResponse<CreatePropertyModel>> {
    return this.apiService.patch(
      environment.listingBaseUrl +
      `/v1/landlords/self/properties/${id}`,
      data
    );
  }

  updateStatus(id: string, status: PropertyStatus): Observable<ApiResponse<CreatePropertyModel>> {
    return this.apiService.patch(
      environment.listingBaseUrl + `/v1/landlords/self/properties/${id}/status`,
      { status }
    );
  }

  submitConsent(id: string, consent: ConsentPayload): Observable<ApiResponse<CreatePropertyModel>> {
    return this.apiService.post(environment.listingBaseUrl + `/v1/landlords/self/properties/${id}/consent`, consent);
  }

  getPropertyTiers(propertyId: string): Observable<ApiResponse<PaginatedResponse<TierModel>>> {
    return this.apiService.get(
      environment.listingBaseUrl + `/v1/landlords/self/properties/${propertyId}/tiers`
    );
  }

}
